import { render, staticRenderFns } from "./PackageCourse.vue?vue&type=template&id=3268defa&scoped=true"
import script from "./PackageCourse.vue?vue&type=script&lang=js"
export * from "./PackageCourse.vue?vue&type=script&lang=js"
import style0 from "./PackageCourse.vue?vue&type=style&index=0&id=3268defa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3268defa",
  null
  
)

export default component.exports